import BaseModelAPI from '../BaseModelAPI';

export default class BeritaAcaraStockOpname extends BaseModelAPI {
	static entity = 'beritaacarastockopname';
	static entityName = 'beritaacarastockopname';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.stockOpnamePlanId = '';
			this.stockOpnamePlan = {};
			this.areaId = '';
			this.area = {};
			this.vendorId = '';
			this.vendor = {};
			this.remarks = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
			this.isStockOpnamed = false;
	/*END_APP_MODEL_DEFINITION*/
	}

}